import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromTermsAccordion from '../../reducers/terms-accordion/terms-accordion.reducer';
import {
  AccordionId,
  TermsAccordionState,
} from '../../reducers/terms-accordion/terms-accordion.reducer';

export const selectTermsAccordionState =
  createFeatureSelector<fromTermsAccordion.TermsAccordionState>('termsAccordion');

export const selectAccordions = createSelector(
  selectTermsAccordionState,
  fromTermsAccordion.getAccordions,
);

export const selectAreAllAccordionsAccepted = createSelector(
  selectTermsAccordionState,
  fromTermsAccordion.getAreAllAccordionsAccepted,
);

export const selectFirstUnacceptedAccordionId = createSelector(
  selectTermsAccordionState,
  fromTermsAccordion.getFirstUnacceptedAccordionId,
);

export const selectCanAccordionBeOpened = (accordionId: AccordionId) =>
  createSelector(selectTermsAccordionState, (state: TermsAccordionState) =>
    fromTermsAccordion.canAccordionBeOpened(state, accordionId),
  );

export const selectAccordionAcceptedDate = (accordionId: AccordionId) =>
  createSelector(selectAccordions, (accordions) => accordions[accordionId]?.acceptedAt ?? '');
